var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctInteger128, FctValue } from '../../../../Fct/generics/FctParams';
import { FaExchangeAlt } from 'react-icons/fa';
import { ETH_ADDRESS, getAllSupportedIndexes, getSupportedIndexes, supportedPools } from '../helpers/supportedContracts';
import { isEqual } from 'lodash';
export var ExchangeOnPool = createPlugin({
    protocol: 'CURVE',
    type: 'ACTION',
    method: 'exchange',
    name: 'exchangeOnPool',
    description: 'Exchange tokens on Curve Finance using a pool address',
    getParams: function (_a) {
        var chainId = _a.chainId;
        var indexOptions = getAllSupportedIndexes(chainId);
        return {
            input: {
                to: new FctAddress({
                    destination: 'curve_pool',
                    options: supportedPools.filter(function (pool) { return pool.chainId === Number(chainId); }),
                    isPreview: true,
                }),
                poolLPToken: new FctAddress({
                    destination: 'curve_pool',
                    readonly: true,
                    isPreview: true,
                }),
                poolGaugeToken: new FctAddress({
                    destination: 'curve_gauge',
                    readonly: true,
                    isPreview: true,
                }),
                value: new FctValue({ readonly: true, required: false }),
                methodParams: {
                    index1: new FctInteger128({
                        description: 'Index value for the coin to send',
                        destination: 'index',
                        options: indexOptions,
                    }),
                    index2: new FctInteger128({
                        description: 'Index value of the coin to receive',
                        destination: 'index',
                        options: indexOptions,
                    }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaExchangeAlt }),
                    amountMinReceived: new FctValue({ destination: 'wei_amount', required: false }),
                },
            },
            output: {
                amountReceived: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
            },
        };
    },
    initParams: {
        methodParams: {
            amountMinReceived: '0',
        },
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, output = _a.output, chainId = _a.chainId;
        var poolLPToken = input.poolLPToken, poolGaugeToken = input.poolGaugeToken;
        var indexOptions = getAllSupportedIndexes(chainId);
        var getParamsAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
            var address, index1, index2, options1, options2, getPrevOptIndex, opt1, opt2, pool;
            var _a, _b;
            return __generator(this, function (_c) {
                address = input.to.value;
                index1 = input.methodParams.index1;
                index2 = input.methodParams.index2;
                if (!address) {
                    index1.options = indexOptions;
                    index2.options = indexOptions;
                    return [2 /*return*/, {
                            params: {
                                poolLPToken: undefined,
                                poolGaugeToken: undefined,
                                value: undefined,
                            },
                            error: undefined,
                        }];
                }
                options1 = getSupportedIndexes(address, chainId);
                options2 = options1;
                if (!isEqual(options1, index1.options) || !isEqual(options2, index2.options)) {
                    index1.options = options1;
                    index2.options = options2;
                    getPrevOptIndex = function (prevParam, index) {
                        if (!(prevParam === null || prevParam === void 0 ? void 0 : prevParam.value))
                            return index;
                        if (typeof prevParam.value === 'string') {
                            var prevIndex = Number(prevParam.value);
                            return (options1 === null || options1 === void 0 ? void 0 : options1[prevIndex]) ? prevIndex : index;
                        }
                        if (prevParam.isVariable) {
                            var prevIndex = Number(prevParam.estimatedValue);
                            return (options1 === null || options1 === void 0 ? void 0 : options1[prevIndex]) ? prevIndex : index;
                        }
                        return index;
                    };
                    opt1 = (_a = index1 === null || index1 === void 0 ? void 0 : index1.options) === null || _a === void 0 ? void 0 : _a[getPrevOptIndex(index1, 0)];
                    opt2 = (_b = index2 === null || index2 === void 0 ? void 0 : index2.options) === null || _b === void 0 ? void 0 : _b[getPrevOptIndex(index2, 1)];
                    if (opt1) {
                        index1.value = opt1.value;
                        index1.decimals = opt1.decimals;
                    }
                    if (opt2) {
                        index2.value = opt2.value;
                        index2.decimals = opt2.decimals;
                    }
                }
                pool = input.to.options.find(function (p) { return p.address === address; });
                if (!pool)
                    return [2 /*return*/, {
                            params: {
                                value: undefined,
                            },
                            error: undefined,
                        }];
                if (pool.implementation === 'tricrypto-1') {
                    index1._fctType = 'uint256';
                    index2._fctType = 'uint256';
                }
                else {
                    index1._fctType = 'int128';
                    index2._fctType = 'int128';
                }
                if (index1.value) {
                    input.methodParams.amount.decimals = Number(pool.coins[Number(index1.value)].decimals);
                }
                if (index2.value) {
                    input.methodParams.amountMinReceived.decimals = Number(pool.coins[Number(index2.value)].decimals);
                    output.amountReceived.decimals = Number(pool.coins[Number(index2.value)].decimals);
                }
                poolLPToken.value = pool.lpTokenAddress;
                poolLPToken.decimals = 18;
                poolLPToken.label = "Curve LP ".concat(pool.symbol);
                poolGaugeToken.value = pool.gaugeAddress;
                poolGaugeToken.decimals = 18;
                poolGaugeToken.label = "Curve Gauge ".concat(pool.symbol);
                if (pool.assetTypeName === 'eth') {
                    input.value.required = true;
                    return [2 /*return*/, {
                            params: {
                                poolLPToken: pool.lpTokenAddress,
                                poolGaugeToken: pool.gaugeAddress,
                                value: input.methodParams.amount.value,
                            },
                            error: undefined,
                        }];
                }
                input.value.required = false;
                return [2 /*return*/, {
                        params: {
                            poolLPToken: pool.lpTokenAddress,
                            poolGaugeToken: pool.gaugeAddress,
                            value: undefined,
                        },
                        error: undefined,
                    }];
            });
        }); };
        return {
            get: getParamsAsync,
            depParamKeys: ['to', 'methodParams.index1', 'methodParams.index2', 'methodParams.amount'],
        };
    },
    requiredApprovals: function (params, chainId) {
        if (params.methodParams.index1.value === ETH_ADDRESS)
            return [];
        var getTokenAddress = function () {
            if (!(params === null || params === void 0 ? void 0 : params.to.value) ||
                typeof (params === null || params === void 0 ? void 0 : params.to.value) !== 'string' ||
                !(params === null || params === void 0 ? void 0 : params.methodParams.index1.value) ||
                typeof (params === null || params === void 0 ? void 0 : params.methodParams.index1.value) !== 'string')
                return undefined;
            var coins = getSupportedIndexes(params === null || params === void 0 ? void 0 : params.to.value, chainId);
            if (!coins)
                return undefined;
            return coins[parseInt(params === null || params === void 0 ? void 0 : params.methodParams.index1.value)].address;
        };
        return [
            {
                to: getTokenAddress(),
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amount.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
